// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sx-9";
export var arrowButtonContainer = "_sx-5";
export var arrowButtonIcon = "_sx-6";
export var carouselArrowButton = "_sx-2";
export var carouselElementContainer = "_sx-1";
export var currentSlide = "_sx-8";
export var left = "_sx-3";
export var otherSlide = "_sx-a";
export var productCarouselContainer = "_sx-0";
export var right = "_sx-4";
export var sliderOverflow = "_sx-7";